__webpack_require__.p = "/aje/2026/how-well-do-you-know-iran-map/";